<template>
    <div style="margin-left: 10px; display: inline">
        <el-button @click="drawerClick" size="mini" icon="el-icon-setting">设置</el-button>
        <el-drawer
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose"
            :modal="false"
            size="14%"
            :close-on-press-escape="closeShow"
            :wrapperClosable="closeShow"
        >
            <div class="drawerList">
                <el-button size="small" type="primary" plain @click="submitData" class="submitBtn">保存</el-button>
                <el-checkbox-group v-model="colSelect">
                    <draggable
                        v-model="colOptions"
                        group="title"
                        style="height: 800px; display: flex; flex-direction: column; overflow-y: scroll"
                    >
                        <transition-group v-for="(item, index) in colOptions" :key="item.title">
                            <el-checkbox :key="index" :label="item.title"></el-checkbox>
                            <input :key="item.prop" type="text" v-model="item.placeholder_detail" class="placeholder_num" />
                        </transition-group>
                    </draggable>
                </el-checkbox-group>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import { in_array } from '@/js/common';
export default {
    //注册draggable组件
    components: {
        draggable
    },
    data() {
        return {
            drawer: false,
            direction: 'rtl',
            colOptions: [],
            colSelect: [],
            closeShow: false,
            data_name: ''
        };
    },

    created() {},
    props: {
        draggable: {
            type: Object
        }
    },
    methods: {
        drawerClick() {
            this.colOptions = [];
            this.colSelect = [];
            this.getDataList();
            this.drawer = true;
        },
        handleClose(done) {
            this.$confirm('取消保存更改？')
                .then((_) => {
                    this.colOptions = [];
                    this.colSelect = [];
                    done();
                })
                .catch((_) => {});
        },
        submitData() {
            this.$confirm('确认保存更改?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.drawer = false;

                    var newArr = {};
                    var l = this.colOptions.length;

                    for (let i = 0; i < l; i++) {
                        if (in_array(this.colOptions[i].title, this.colSelect)) {
                            this.colOptions[i].is_show_detail = true;
                        } else {
                            this.colOptions[i].is_show_detail = false;
                        }
                        newArr[this.colOptions[i].prop] = this.colOptions[i];
                    }

                    var storageArr = JSON.parse(localStorage.getItem('detailList'));
                    storageArr[this.data_name] = newArr;
                    localStorage.setItem('detailList', JSON.stringify(storageArr));
                    //改变结构 宽度 就调用接口
                    let params = {
                        object_type: this.data_name,
                        object: this.colOptions,
                        type: 'detail'
                    };
                    this.filedSave(params);
                })
                .catch(() => {});
        },
        // 保存
        filedSave(params) {
            this.$api
                .fieldSave(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.$emit('isErrshow'); //事件发射
                    }
                })
                .catch((error) => {});
        },
        getDataList() {
            this.drawer = this.draggable.drawer;
            let colData = JSON.parse(localStorage.getItem('detailList'))[this.data_name];

            this.colOptions = Object.values(colData);
            var l = this.colOptions.length;
            for (let index = 0; index < l; index++) {
                if (this.colOptions[index].is_show_detail) {
                    this.colSelect.push(this.colOptions[index].title);
                }
            }
        }
    },
    mounted() {
        this.data_name = this.draggable.data_name;
    }
};
</script>
<style  lang="scss" scoped>
.drawerList {
    text-align: left;
    box-sizing: border-box;
    padding-left: 10px;
}
.placeholder_num {
    width: 30px;
    color: orange;
    border: 0;
    margin-left: 5px;
}
</style>
